import { render, staticRenderFns } from "./CategoriasDispositivos.vue?vue&type=template&id=4096eee2"
import script from "./CategoriasDispositivos.vue?vue&type=script&lang=js"
export * from "./CategoriasDispositivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports